import {Injectable} from '@angular/core';

@Injectable()
export class DateHelperService {
    constructor() {
    }

    daysBetween(date1, date2) {
        // The number of milliseconds in one day
        const ONE_DAY = 1000 * 60 * 60 * 24;

        // Convert both dates to milliseconds
        const date1_ms = date1.getTime();
        const date2_ms = date2.getTime();

        // Calculate the difference in milliseconds
        const difference_ms = Math.abs(date1_ms - date2_ms);

        // Convert back to days and return
        return Math.round(difference_ms / ONE_DAY);

    }

    monthsBetween(date1, date2) {
        return date2.getMonth() - date1.getMonth() +
            (12 * (date2.getFullYear() - date1.getFullYear()));

    }

    parseDbDate(str) {
        if (str == null || str === '') {
            return null;
        }
        return new Date(str.substring(0, 4), str.substring(5, 7) - 1, str.substring(8, 10));
    }
}
